import React from 'react';
import { Redirect } from 'react-router';

interface ErrorBoundaryInternalState {
    error: boolean;
}

class ErrorBoundary extends React.Component<{}, ErrorBoundaryInternalState> {
    state: Readonly<ErrorBoundaryInternalState> = { error: false };

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        this.setState({ error: true });
    }

    render(): any {
        if (this.state.error) {
            return (<Redirect to="/error" />);
        }
        return React.Children.only(this.props.children);
    }
}

export { ErrorBoundary };
